import { useState, useEffect, useCallback, useMemo } from 'react';
import { animated, useSpring } from "react-spring";
import './App.css';
import { useDispatch, useSelector } from 'react-redux'
import { initPlayerState, setPlayerId, setHost, setPlayerColour, setPlayerName } from './redux/playerState';
import { initGameState, setGameRoom, updatePlayers, updateMessages } from './redux/gameState';
import io from 'socket.io-client';
import { initConfigState } from './redux/configState';

function Welcome(props) {

  const dispatch = useDispatch();

  const [name, setName] = useState("");
  const [room, setRoom] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [createBtnDsiabled, setCreateBtnDsiabled] = useState(false);
  const gameState = useSelector((state) => state.gameState);

  const player = useMemo(() => ({
    id: props.PID,
    name: name,
    host: true,
    faker: false,
    colour: "",
    voted: false,
    myVote: ""
  }), [props.PID, name]);

  // let game = {
  //   "players": [player],
  //   "room" : room,
  //   "turn" : 0,
  //   "drawing": "",
  //   "ready": false,
  //   "word" : "",
  //   "voting": false,
  //   // hate this below
  //   "voteComplete": false,
  //   "messages": [],
  //   "faker": {},
  //   "round": 0,
  //   "config": {},
  // }

  let game = gameState;

  const handleJoinRoom = useCallback((e) => {
    e.preventDefault();
    setErrMsg("");
    if (!name || name === null) {
      setErrMsg("A display name is required");
      return;
    }
    if (isNaN(parseInt(room))) {
      setErrMsg("Room code must be a number");
      return;
    }
    if (!room || room === null) {
      return;
    }
    dispatch(setGameRoom(room));
    configureStates(player, gameState);

    const socket = io(process.env.REACT_APP_API_URL, {
      transports: ["websocket"],
    });
    props.socket(socket);
    console.log("gameState in welcome: ", gameState);
    socket.emit('joinRoom', gameState, player, (response) => {
      if (!response.err) {
        dispatch(setPlayerId(response.playerId));
        dispatch(setHost(response.host));
        dispatch(initConfigState(response.config));
        dispatch(setPlayerColour(response.colour));
        dispatch(setGameRoom(response.room));
        dispatch(updatePlayers(response.playerList));
        dispatch(updateMessages(response.messages));
        dispatch(setPlayerName(response.playerList.find(p => p.id === response.playerId).name));
        springCallback();
      }
      else {
        setErrMsg(response.err);
      }
    });

    socket.once("noGameFound", (rm) => {
      setErrMsg("Room number " + rm + " not found");
      setRoom("");
    });
    return () => {
      socket.off('noGameFound');
    };
  }, [name, room, gameState, player, dispatch]);

  const changeRoom = (r) => {
    if (r !== null || r.trim() !== "" || /^[+-]?\d+(\.\d+)?$/.test(r))
      setRoom(r);
  }

  const handleNewRoom = useCallback((e) => {
    e.preventDefault();
    setErrMsg("");
    if (name.trim() === "") {
      setErrMsg("A display name is required");
      return;
    }
    // to change
    const socket = io(process.env.REACT_APP_API_URL, {
      transports: ["websocket"],
    })
    props.socket(socket);

    // dispatch(setGameRoom(room));

    configureStates(player, game);

    socket.emit('createNewRoom', game, player, (response) => {
      if (!response.err) {
        dispatch(setPlayerId(response.playerId));
        dispatch(setPlayerColour(response.playerColour));
        dispatch(updatePlayers(response.playerList));
        dispatch(setHost(response.host));
        dispatch(setGameRoom(response.room));
        springCallback();
      }
      else {
        setErrMsg(response.err);
      }
    });
  }, [name, gameState, player, props]);

  const configureStates = (p, g) => {
    dispatch(initPlayerState(p));
    dispatch(initGameState(g));
  }

  useEffect(() => {
    setCreateBtnDsiabled(false);
    if (room !== null && room.trim() !== "") {
      setCreateBtnDsiabled(true);
      dispatch(setGameRoom(room));
    }
  }, [room, dispatch]);

  function springCallback() {
    welcomePosApi.start({
      y: -1000,
      rotateZ: -45,
      onRest: () => props.lobbyStart(true),
    });
  }

  const [welcomePos, welcomePosApi] = useSpring(() => ({
    from: {
      y: 0,
      rotateZ: 0
    },
    config: { duration: 300 },
    onRest: () => props.lobbyStart(true),
  }))

  return (
    <animated.div className="px-12 lg:px-0 col-span-12 lg:col-span-4 lg:col-start-5 xl:col-span-4 xl:col-start-4 xl:col-span-6 xl:text-lg md:text-md text-sm xl:mt-4 mb-40 sm:mb-0" style={{ ...welcomePos }}>
      <div className="bg-gray-100 shadow-2xl md:p-10 px-6 bg-white rounded p-8">
        <h5 className="pb-2 pt-1 m-0 border-b-2">Welcome, please enter a name and room code to play, or create a new room</h5>
        <p className="pb-2 pt-1 m-0">{errMsg}</p>
        <form>
          <p><label className="">
            Display Name:
            <input className="text-black input border border-gray-400 appearance-none rounded w-full px-3 py-3 pt-2 pb-2 focus focus:border-indigo-600 focus:outline-none active:outline-none active:border-indigo-600"
              type="text" onChange={e => setName(e.target.value)} maxLength="12" />
          </label>
          </p>
          <p>
            <label className="">
              Room Code:
              <input className="text-black input border border-gray-400 appearance-none rounded w-full px-3 py-3 pt-2 pb-2 focus focus:border-indigo-600 focus:outline-none active:outline-none active:border-indigo-600"
                type="text" inputMode="numeric" onChange={e => changeRoom(e.target.value)} maxLength="10" />
            </label>
          </p>
          <button onClick={(e) => handleNewRoom(e)} className={((createBtnDsiabled) ? 'disabled:opacity-50 ' : '') + "newRoomBtn m-3 bg-blue-500 hover:bg-blue-700 font-bold py-2 px-4 rounded"} disabled={createBtnDsiabled}>Create new room?</button>
          <button onClick={(e) => handleJoinRoom(e)} type="submit" value="Submit" className={((!createBtnDsiabled) ? 'disabled:opacity-50 ' : '') + "m-3 bg-green-500 hover:bg-green-700 font-bold py-2 px-4 rounded"} disabled={!createBtnDsiabled}>Submit</button>
          {props.gameStatus === "full" ? <p className="gameJoinErr">The entered room code is full or in progress</p> : ''}
        </form>
      </div>
    </animated.div>
  );
}

export default Welcome;
